import { Component, EventEmitter, Input, OnInit, Output, ViewContainerRef,HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { NavigationService } from 'src/app/service/navigation.service';

@Component({
	selector: 'app-portal-header-mobile',
	templateUrl: './portal-header-mobile.component.html',
	styleUrls: ['./portal-header-mobile.component.css']
})
export class PortalHeaderMobileComponent implements OnInit {

	@Output() onMenuChange: EventEmitter<boolean> = new EventEmitter();
	isSticky: boolean = false;
	/** Tableta 768-1023px (frame Figma 768-1023): logo completo + botón Cotizar + hamburguesa */
	isTablet: boolean = typeof window !== 'undefined' && window.innerWidth >= 768 && window.innerWidth < 1024;

	@HostListener('window:resize', [])
	onResize() {
		this.isTablet = window.innerWidth >= 768 && window.innerWidth < 1024;
	}

	get showQuoteButton(): boolean {
		if (this.router.url === '/quote-app/quote') return false;
		return this.isTablet || this.router.url !== '/';
	}
	constructor(
		public router: Router,
		private navigate: NavigationService
	) {
	}
	@HostListener('document:scroll', [])
	onWindowScroll() {
		const offset = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
	
		if (offset > 100) {
		  this.isSticky = true;
		} else {
		  this.isSticky = false;
		}
}
	ngOnInit() {
	}

	goHome() {
		this.navigate.navigateToHome()
	}

	menuChange(){
		this.onMenuChange.emit();
	}
	goQuote() {
		this.navigate.navigateToQuote()
		this.menuChange()
	}
}
